import { formatMenuUrl, isExternalLink, normalizeUrl } from "@/utils/ensure-protocol-helper"

export interface ProcessedMenuUrl {
  normalizedUrl: string
  finalUrl: string
  isExternal: boolean
}

/**
 * Process menu URL - normalize, format, and check if external
 */
export const processMenuUrl = (url: string | undefined | null, locale: string): ProcessedMenuUrl => {
  const normalizedUrl = normalizeUrl(url || '/')
  const finalUrl = formatMenuUrl(normalizedUrl, locale)
  const isExternal = isExternalLink(normalizedUrl)

  return {
    normalizedUrl,
    finalUrl,
    isExternal,
  }
}

/**
 * Get active menu item ID based on pathname
 */
export const getActiveMenuItemId = (
  structuredMenu: Array<{ id: number; url: string; attribute?: Array<{ url: string }> }> | undefined,
  pathname: string,
  locale: string
): number | null => {
  if (!structuredMenu) return null

  for (const item of structuredMenu) {
    // Check if pathname matches item URL
    if (!item.attribute && pathname === item.url) {
      return item.id
    }

    // Check if pathname includes any submenu item URL
    if (item.attribute?.some(subItem => pathname.includes(subItem.url))) {
      return item.id
    }

    // Check if pathname matches item URL with locale prefix
    if (pathname === `/${locale}${item.url}`) {
      return item.id
    }
  }

  return null
}
